import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { motion, AnimatePresence } from "framer-motion";

type SectionProps = {
  icon: React.ReactNode;
  title: string;
  isOpen: boolean;
  onToggle: () => void;
  children: React.ReactNode;
};

export default function SectionProperty({
  icon,
  title,
  isOpen,
  onToggle,
  children,
}: SectionProps) {
  return (
    <div className="space-y-3">
      <div
        onClick={onToggle}
        className="flex items-center justify-between cursor-pointer"
      >
        <div className="flex items-center gap-2 font-bold text-gray-800">
          {icon}
          <span>{title}</span>
        </div>
        {isOpen ? <IoIosArrowUp /> : <IoIosArrowDown />}
      </div>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.25 }}
          >
            {children}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
